import loader from 'cs-shared-component-tools';
import { Env } from 'cs-shared-component-tools/dist/type';

export async function loadCsSharedComponent() {
  const envVal = (ENVIRONMENT as unknown) as Env;
  const region = COUNTRY;
  const params = {
    env: envVal,
    region,
    modules: [
      { name: 'foody-order-dialog', version: '1.0.17' },
    ],
  };
  try {
    const res = await loader.load(params);
    return res;
  } catch (err) {
    //
  }
}
